import React, { useEffect, useState } from "react";
import axios from "axios";
import { Api } from "../../../api/index.js";
import { Headers } from "../../../api/actions.js";
import Loading from "../../../components/loading/loading.jsx";

import NavbarLeft from "../../../components/navbar/navbar_left";
import NavbarTop from "../../../components/navbar/navbar_top";
import { useParams } from "react-router";
import ExamsEditContent from "../component/exam-edit/exam-edit-content.jsx";
import axiosInstance from "../../../api/axios_instance.jsx";

const ExamsEdit = () => {
  const { id } = useParams();

  const ObJectArrayData = [
    {
      id: 2,
      href: `/exams/page:${1}/search:${""}`,
      title: "الاختبارات",
    },
  ];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetData(id, setData, setLoading);
  }, [id]);

  if (!loading) {
    return (
      <section className="main">
        <NavbarLeft />
        <div className="main-body">
          <NavbarTop ArrayData={ObJectArrayData} />
          <div className="main-body__content">
            <Loading />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="main">
      <NavbarLeft />
      <div className="main-body">
        <NavbarTop ArrayData={ObJectArrayData} />
        <div className="main-body__content">
          <ExamsEditContent Arraydata={data} />
        </div>
      </div>
    </section>
  );
};

export default ExamsEdit;

const GetData = async (id, setData, setLoading) => {
  const options = {
    method: "post",
    url: `${Api}Test/GetTestData`,
    headers: Headers,
    data: {
      id: id,
    },
  };
  await axiosInstance(options)
    .then(function (response) {
      setData(response.data.responseObject);
      setLoading(true);
    })
    .catch(function (error) {
      setLoading(true);
    });
};
